import {
  InteractionType,
  PopupRequest,
  PublicClientApplication,
  RedirectRequest,
} from "@azure/msal-browser";
import { AUTH_TOKEN_KEY, REFRESH_TOKEN_KEY, TASK_TYPES } from "core/constants";
import { msalInstance, tokenRequest } from "../authConfig";
export * from "./time";
import store from 'store'

export async function isAuthenticated(
  instance: PublicClientApplication,
  interactionType: InteractionType,
  loginRequest: PopupRequest | RedirectRequest
): Promise<boolean> {
  // If your application uses redirects for interaction, handleRedirectPromise must be called and awaited on each page load before determining if a user is signed in or not
  return instance
    .handleRedirectPromise()
    .then(() => {
      const accounts = instance.getAllAccounts();
      if (accounts.length > 0) {
        return true;
      }

      // User is not signed in and attempting to access protected route. Sign them in.
      if (interactionType === InteractionType.Popup) {
        return instance
          .loginPopup(loginRequest)
          .then(() => {
            return true;
          })
          .catch(() => {
            return false;
          });
      } else if (interactionType === InteractionType.Redirect) {
        return instance
          .loginRedirect(loginRequest)
          .then(() => {
            return true;
          })
          .catch(() => {
            return false;
          });
      }

      return false;
    })
    .catch(() => {
      return false;
    });
}

export function checkTokenExpire(token: string | null) {
  if (!token) {
    return true;
  }
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  const jwtPayload = JSON.parse(jsonPayload);
  if (jwtPayload.exp < Date.now() / 1000) {
    return true;
  } else {
    return false;
  }
}

export function convertTaskIdToType(taskTypeId: number) {
  switch (taskTypeId) {
    case 0:
      return TASK_TYPES.Rental.toString();
    case 1:
      return TASK_TYPES.Force.toString();
    default:
      return TASK_TYPES.Force.toString();
  }
}

export function convertTaskIdToTypeText(taskTypeId: number) {
  switch (taskTypeId) {
    case 0:
      return 'Rental';
    case 1:
      return 'Unbilled';
    case 2:
      return 'Job Cost';
    default:
      return 'Job Cost';
  }
}

export function formatTime(timeVal: string): TimeObject{
  let timeObj: TimeObject = {
    hour: 0,
    minutes: 0,
    isAm: true,
    hours: 0,
  };
  
  if(timeVal){
    const newStr = timeVal.replace('PT', '').replace('M', '').replace('H', ':').replace('S','');
    if(!newStr.includes(":")){
      if(newStr === '0') {
        return {
          hour: 12,
          minutes: 0,
          isAm: true,
          hours: 12,
        }
      } else {
        return {
          hour: 12,
          minutes: Number(newStr),
          isAm: true,
          hours: 12,
        }
      }
    }
    let [strHour, strMins] = newStr.split(':');
    if (!strMins) {
      strMins = '0'
    }
    if(strHour && strMins){
      timeObj.hours = Number(strHour);
      timeObj.minutes = Number(strMins);
      let isAm  = true;
      if(timeObj.hours > 12){
        isAm = false;
        timeObj.hour = timeObj.hours - 12;
      }else{
        timeObj.hour = timeObj.hours;
        if(timeObj.hours === 12) {
          isAm = false;
        }
      }
      timeObj.isAm = isAm;
    }
  }

 return timeObj;
}

export function convertStrToTime (timeVal: any){
  let str = 'PT00H00M';
  //12:00:00.00
  if(timeVal){
    const [strFullTime, strmiliSec] = timeVal.split('.');
    if(strFullTime){
      const [hour, min, sec] = strFullTime.split(':');
      const value = `PT${hour.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}H${min.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}M`;
      str = value;
    }
  }

  return str;
}

export function convertStatusTimeSheet(status?: number) {
  switch (status) {
    case 0:
      return 'Draft';
    case 1:
        return 'Pending Approval';
    case 2:
      return 'Approved';
    case 3:
      return 'Declined';
    case 5:
        return 'Cancelled';
    default:
      return 'Draft';
  }
}

export function clearAllCookies() {
  // Get all cookies as a string (name=value; pairs)
  const cookies = document.cookie.split(';');
  // Loop through and delete each cookie
  cookies.forEach((cookie) => {
    // Extract cookie name
    const cookieName = cookie.split('=')[0].trim();
    // Set each cookie's expiration to a past date to delete it
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${location.hostname}`;
  });
}

export function getCookie(name: string) {
  function escape(s: string) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
  return match ? match[1] : null;
}

export async function autoRefreshToken () {
  window.location.href = '/login';
  localStorage.setItem(AUTH_TOKEN_KEY, '');
  sessionStorage.removeItem(AUTH_TOKEN_KEY)
  document.cookie = `${REFRESH_TOKEN_KEY}=`;
}

export async function clearCookie () { 
  var cookies = document.cookie.split("; ");
  for (var c = 0; c < cookies.length; c++) {
    var d = window.location.hostname.split(".");
    while (d.length > 0) {
        var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
        var p = location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
            document.cookie = cookieBase + p.join('/');
            p.pop();
        };
        d.shift();
    }
  }
}

export async function autoForceLogout () {
  await store.dispatch("profile/forceLogout");
  let currentUser = store.getters["auth/currentUser"];
  if (currentUser?.userId === undefined) {
    // frist login
    currentUser = await store.dispatch("auth/actGetMe");
    if (!currentUser){
      localStorage.setItem(AUTH_TOKEN_KEY, '');
      sessionStorage.setItem(AUTH_TOKEN_KEY, '');
      msalInstance.logoutRedirect()
    }
  } else {
    // had token
    localStorage.setItem(AUTH_TOKEN_KEY, '');
    sessionStorage.setItem(AUTH_TOKEN_KEY, '');
    msalInstance.logoutRedirect()
  }
}